import {Model} from 'MWC';

const loyal_schema_one = 'loyal_schema_one',
    loyal_schema_two = 'loyal_schema_two',
    loyal_schema_three = 'loyal_schema_three',
    loyal_schema_four = 'loyal_schema_four',
    loyal_schema_five = 'loyal_schema_five',
    loyal_schema_six = 'loyal_schema_six',
    loyal_schema_seven = 'loyal_schema_seven',
    loyal_schema_eight = 'loyal_schema_eight',
    loyal = 'loyal',
    oneTimeCommission = 'one_time_commission',
    timeUnit = 'time_unit',
    realRate = 'real_rate',
    months = 12,
    hundredPercent = 100,
    daysInTheYear = 365,
    bankDays = 360;

export default class extends Model {
    static fields;

    constructor(data, selectedType) {
        super();
        this.selectedType = loyal_schema_five;
        this.creditSum = data[selectedType].min;
        this.loanTerm = 0;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.creditCost = 0;
        this._initVariables();
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            loyal_schema_one: data[loyal_schema_one],
            loyal_schema_two: data[loyal_schema_two],
            loyal_schema_three: data[loyal_schema_three],
            loyal_schema_four: data[loyal_schema_four],
            loyal_schema_five: data[loyal_schema_five],
            loyal_schema_six: data[loyal_schema_six],
            loyal_schema_seven: data[loyal_schema_seven],
            loyal_schema_eight: data[loyal_schema_eight],
            loyal: data[loyal]
        };
    }

    _initVariables() {
        this.creditSum = 10000;
        this.loanTerm = 1;
    }

    getCalculatorType() {
        return this.selectedType;
    }

    switchType(type) {
        this.selectedType = type;
    }

    changeField(name, value) {
        this[name] = value;
        this.calculateIndicators();
    }

    getCreditSum() {
        return +this.creditSum;
    }

    setCreditSum(value) {
        this.creditSum = value;
    }

    getMinSumEdge() {
        const type = this.getCalculatorType();
        return +this.fields[type].min;
    }

    getMaxSumEdge() {
        const type = this.getCalculatorType();
        return +this.fields[type].max;
    }

    getSumStep() {
        const type = this.getCalculatorType();
        return +this.fields[type].step;
    }

    getTerms() {
        const type = this.getCalculatorType();
        return this.fields[type].terms;
    }

    getCurrentLoanTerm() {
        return this.loanTerm;
    }

    setCurrentLoanTerm(value) {
        this.loanTerm = value;
    }

    getTimeUnit() {
        const type = this.getCalculatorType();
        return this.fields[type][timeUnit];
    }

    getCreditTerm() {
        return +this.getTerms()[this.getCurrentLoanTerm()];
    }

    getCreditRate() {
        const type = this.getCalculatorType();
        return this.fields[type].rate;
    }

    getRealRate() {
        const type = this.getCalculatorType(),
            term = this.getCurrentLoanTerm();

        return this.fields[type][realRate][term];
    }

    getOneTimeCommission() {
        const type = this.getCalculatorType();
        return this.fields[type][oneTimeCommission];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getOverpayment() {
        return this.overpayment;
    }

    setOverpayment(value) {
        this.overpayment = value;
    }

    getCreditCost() {
        return this.creditCost;
    }

    setCreditCost(value) {
        this.creditCost = value;
    }

    calculateCreditSum() {
        const creditSum = this.getCreditSum();
        return +creditSum + (creditSum * this.getOneTimeCommission()) / hundredPercent;
    }

    resetIndicators() {
        this.setCreditSum(this.getMinSumEdge());
        this.setCurrentLoanTerm(0);
    }

    calculateIndicators() {
        const creditSum = this.calculateCreditSum(),
            interestRate = this.getCreditRate(),
            monthInterestRate = interestRate / months,
            term = this.getCreditTerm();

        const requiredPayment =
                Math.round(
                    ((((creditSum * monthInterestRate) / hundredPercent) * daysInTheYear) /
                        bankDays /
                        (1 -
                            Math.pow(
                                1 +
                                    +(
                                        ((monthInterestRate / hundredPercent) * daysInTheYear) /
                                        bankDays
                                    ),
                                -term
                            ))) *
                        100
                ) / 100,
            overpayment = Math.round((requiredPayment * term - creditSum) * 100) / 100;

        this.setRequiredPayment(requiredPayment);
        this.setOverpayment(overpayment);

        const creditCost = creditSum + overpayment;
        this.setCreditCost(creditCost);
    }
}
